/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

const NotImplementedFieldDisplay = () => {
    
    return (
        <Fragment></Fragment>
    );
};
NotImplementedFieldDisplay.displayName = "NotImplementedFieldDisplay";
export { NotImplementedFieldDisplay };
